import { render, staticRenderFns } from "./AcademyModalComponent.vue?vue&type=template&id=66123132&scoped=true&"
import script from "./AcademyModalComponent.vue?vue&type=script&lang=js&"
export * from "./AcademyModalComponent.vue?vue&type=script&lang=js&"
import style0 from "./AcademyModalComponent.vue?vue&type=style&index=0&id=66123132&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66123132",
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BImg, BRow, BButton, BLink, BCol, BAvatar, BContainer, BModal} from 'bootstrap-vue'
    installComponents(component, {BImg, BRow, BButton, BLink, BCol, BAvatar, BContainer, BModal})
    

export default component.exports